import { platformGraph } from "@/api/platform-graph";
import { unwrapEnvelope } from "@/api/errors";
import type { paths } from "@/api/schema.generated";

type Endpoint = paths["/v1/me/home-dashboard"];
export type HomeLayoutState = Endpoint["get"]["responses"][200]["content"]["application/json"]["data"];
export type SaveHomeLayout = Endpoint["put"]["requestBody"]["content"]["application/json"];
export const fetchHomeLayout = (): Promise<HomeLayoutState> => unwrapEnvelope(platformGraph.GET("/v1/me/home-dashboard"));
export const saveHomeLayout = (body: SaveHomeLayout, key: string): Promise<HomeLayoutState> => unwrapEnvelope(platformGraph.PUT("/v1/me/home-dashboard", { body, params: { header: { "x-idempotency-key": key } } }));
